import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../Footer/Footer";
import LightFoodCard from "./LightFoodCard";
import SectionOneImage from "../Recipes/Images/recipe-banner-img.png";
import './AllFoods.css';
import { buildApiUrl } from "../../config/api.config";

const AllFoods = ({ showAlert }) => {
  const [foodList, setFoodList] = useState([]);
  const [category, setCategory] = useState("All");
  const [loading, setLoading] = useState(true);

  const fetchFoodList = async () => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const selectedRestId = localStorage.getItem("currentRestaurantId");
      let activeRestaurantId = (userDetails?.role === 'owner' || userDetails?.role === 'user') ? selectedRestId : userDetails?.restaurantId;

      if (activeRestaurantId && typeof activeRestaurantId === 'object') {
          activeRestaurantId = activeRestaurantId._id;
      }

      if (!activeRestaurantId) {
        setFoodList([]);
        setLoading(false);
        return;
      }

      const response = await axios.get(buildApiUrl(`/food/list?restaurantId=${activeRestaurantId}`));
      setFoodList(response.data.data);
    } catch (error) {
      console.error("Error fetching food list:", error);
      if (showAlert) showAlert("Error fetching food list", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFoodList();
  }, []);

  // Extract unique categories from the food list dynamically
  const uniqueCategories = ["All", ...new Set(foodList.map(item => item.category).filter(Boolean))];

  // Filter food based on selected category
  const filteredFoodList = category === "All" 
    ? foodList 
    : foodList.filter(item => item.category === category);

  return (
    <div className="all-foods-page">
      {/* Hero Section */}
      <div 
        className="all-foods-hero" 
        style={{ 
          backgroundImage: `linear-gradient(rgba(10, 10, 12, 0.85), rgba(10, 10, 12, 0.95)), url(${SectionOneImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderBottom: 'none'
        }}
      >
        <div className="all-foods-hero-content">
          <h1 className="all-foods-title">Full Culinary Menu</h1>
          <p className="all-foods-subtitle">
            Explore our complete collection of meticulously crafted dishes. From appetizing starters to decadent desserts, every item is prepared with passion and the finest ingredients.
          </p>
        </div>
      </div>

      {/* Category Filter */}
      {!loading && foodList.length > 0 && (
        <div className="all-foods-filter-container">
          {uniqueCategories.map((cat, index) => (
            <button
              key={index}
              className={`all-foods-filter-btn ${category === cat ? 'active' : ''}`}
              onClick={() => setCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      {/* Menu Grid */}
      <div className="all-foods-grid">
        {loading ? (
          <div className="all-foods-empty">Curating menu...</div>
        ) : filteredFoodList.length === 0 ? (
          <div className="all-foods-empty">No dishes found in this category.</div>
        ) : (
          filteredFoodList.map((item, index) => (
            <LightFoodCard
              key={index}
              id={item._id}
              name={item.name}
              description={item.description}
              price={item.price}
              image={item.image}
              date={item.date}
              category={item.category}
            />
          ))
        )}
      </div>

      <div style={{ marginTop: '5rem' }}>
        <Footer />
      </div>
    </div>
  );
};

export default AllFoods;
